import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-comic-image',
  templateUrl: './comic-image.component.html',
  styleUrls: ['./comic-image.component.sass']
})


export class ComicImageComponent implements OnInit {

  @Input() comicPage: { chapter: number; pageNumber: number; };

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void	{
    this.imageLink = this.getImageLink(this.comicPage.pageNumber, this.comicPage.chapter)
    this.chapterNumber = this.comicPage.chapter.toString();
    this.imageNumber = this.comicPage.pageNumber.toString();
  }

  chapterNumber : string; //These suck
  imageNumber : string; //These suck
  imageLink : string;
  imagePath : string = "../../../assets/";
  chapterTag: string = "Chapter_";
  imageTag : string = "Page_";
  imageFileFormat: string = ".png";
  getImageLink(pageNumber, chapterNumber) : string  
  {
      if(chapterNumber == 0)
      {
          //Pilot
          return this.imagePath + this.imageTag + pageNumber + this.imageFileFormat;
      }
      return this.imagePath + this.chapterTag + chapterNumber + "_" + this.imageTag + pageNumber + this.imageFileFormat;
  }

}
